var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-bar'),_c('header-bar',{key:_vm.$route.fullPath}),_c('div',{staticClass:"container section"},[_c('div',[_vm._t("default")],2)]),_c('footer-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }